/***
 *
 *   BADGE
 *   Solid pill. Styling matches ui-reference/src/components/ui/badge.tsx.
 *
 *   PROPS
 *   text: string to be displayed
 *   variant: neutral/count/urgent/high/medium/low/pending/inProgress/onHold/
 *            completed/closed (preferred)
 *   color: LEGACY — blue/red/green/orange
 *   icon: trailing icon name (optional)
 *
 **********/

import { ClassHelper, Icon } from 'components/lib';
import Style from './badge.tailwind.js';

export function Badge(props) {
    const variant = props.variant || props.color || 'neutral';

    const badgeStyle = ClassHelper(Style, {
        [variant]: true,
        className: props.className,
    });

    return (
        <span className={badgeStyle} onClick={props.action}>
            {props.text}
            {props.icon && (
                <span className={Style.iconParent} onClick={props.onIconClick}>
                    <Icon
                        image={props.icon}
                        color={props.colorIcon || 'currentColor'}
                        size={props.sizeIcon || 12}
                    />
                </span>
            )}
        </span>
    );
}
